import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api, C } from "../../lib/api";

// Scrolling announcement strip across the very top of every table room; staff edit the messages in /admin.
export const Ticker = ({ flash = null, onFlashDone, lines = null }) => {
  const [messages, setMessages] = useState([]);
  // flash: {id, text, repeats} — crosses the strip `repeats` times on top of the news, then is dropped
  const flashDur = flash ? Math.max(12, Math.round((flash.text.length + 120) / 14)) : 0;
  useEffect(() => {
    if (!flash) return;
    const t = setTimeout(() => onFlashDone && onFlashDone(flash.id), flashDur * (flash.repeats || 1) * 1000 + 200);
    return () => clearTimeout(t);
  }, [flash, flashDur, onFlashDone]);
  useEffect(() => {
    const load = () => api.get(C.ApiRoutes.ANNOUNCEMENTS).then((r) => setMessages(r.data.messages)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  const list = lines?.length ? lines : messages;   // a club table runs the club's own ticker
  if (!list.length && !flash) return null;
  const line = list.join("   ✦   ");
  const dur = Math.max(18, Math.round(line.length / 6));
  return (
    <div data-testid="ticker" className="relative z-20 h-7 flex items-center bg-black/70 border-b border-amber-300/30 overflow-hidden text-[12px] tracking-wide text-amber-100">
      <div className="absolute left-0 top-0 bottom-0 flex items-center gap-1.5 pl-4 pr-3 bg-black/90 z-10 text-amber-400 text-[10px] font-display tracking-[0.25em] border-r border-amber-300/20"><Megaphone className="w-3.5 h-3.5" /> NEWS</div>
      <div className={`ticker-track flex whitespace-nowrap ${flash ? "opacity-20" : ""}`} style={{ animationDuration: `${dur}s` }}>
        <span data-testid="ticker-text" className="px-12">{line}</span>
        <span aria-hidden className="px-12">{line}</span>
      </div>
      {flash && (
        <div key={flash.id} data-testid="ticker-flash" className="ticker-flash absolute left-0 top-0 bottom-0 flex items-center whitespace-nowrap font-display text-amber-300 pl-24"
          style={{ animationDuration: `${flashDur}s`, animationIterationCount: flash.repeats || 1 }}>★ {flash.text} ★</div>
      )}
    </div>
  );
};
